import { SimpleProductItem } from 'lib/core/data/quote/addProduct/types'
import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface AddGiftcardProductToCartMutationObject {
  mutation: {
    addGiftcardProductsToCart: {
      __args: {
        input: {
          cart_id: string
          cart_items: Record<string, any>
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const addGiftcardProductToCartMutationObject: AddGiftcardProductToCartMutationObject = {
  mutation: {
    addGiftcardProductsToCart: {
      __args: {
        input: {
          cart_id: '',
          cart_items: []
        }
      }
    }
  }
}

interface AddGiftcardProductToCartMutationInput {
  cartId: string
  cartItems: SimpleProductItem[]
  message: string
  senderName: string
  senderEmail: string
  recipientName: string
  recipientEmail: string
  giftCardAmount: string
  productId: string
}

export type AddGiftcardProductToCartMutation = (input: AddGiftcardProductToCartMutationInput) => Promise<FetchResult<any>>

export const createAddGiftcardProductToCartMutation = ({ getMutations, getQueries }: ServiceDependencies): AddGiftcardProductToCartMutation => async (input) => {
  const queries = getQueries()
  const {
    cartId,
    cartItems,
    message,
    senderName,
    senderEmail,
    recipientName,
    recipientEmail,
    giftCardAmount,
    productId
  } = input

  const items = cartItems.map((item: any) => {
    const {
      quantity,
      sku,
      ...rest
    } = item

    return {
      giftcard: {
        giftcard_amount: giftCardAmount,
        giftcard_message: message,
        giftcard_sender_name: senderName,
        giftcard_sender_email: senderEmail,
        giftcard_recipient_name: recipientName,
        giftcard_recipient_email: recipientEmail,
        product: productId
      },
      data: {
        ...rest,
        quantity,
        sku
      }
    }
  })

  const mutation = getMutations().addGiftcardProductToCartMutation
  mutation.mutation.addGiftcardProductsToCart.__args.input.cart_id = cartId
  mutation.mutation.addGiftcardProductsToCart.__args.input.cart_items = items
  mutation.mutation.addGiftcardProductsToCart = {
    ...mutation.mutation.addGiftcardProductsToCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
